import Vue from 'vue'
import Router from 'vue-router'
import i18n from '../i18n'
import storage from "../fetch/storage";
import store from '../store';
import api from '../fetch/api'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import {getTenantLoginPath, stripTenantPrefix, syncTenantKeyFromRoute} from '@/utils/tenantLogin'

NProgress.configure({showSpinner: false})

Vue.use(Router)
const infoMsg = storage.get('infoMsg')
let activeMenu;
if (infoMsg) {
    store.commit('setTenantId', infoMsg.tenantId)
    store.commit('setTenantKey', infoMsg.tenantKey)
}
const baseRouter = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login'),
        meta: {
            title: 'router.login'
        }
    },
    {
        path: '/lt/login',
        name: 'ltLogin',
        component: () => import('@/views/login/lt/login'),
        meta: {
            title: 'router.login'
        }
    },
    {
        path: '/btsz/login',
        name: 'btszLogin',
        component: () => import('@/views/login/btsz/login'),
        meta: {
            title: 'router.login'
        }
    },
    {
        path: '/yssz/login',
        name: 'ysszLogin',
        component: () => import('@/views/login/yssz/login'),
        meta: {
            title: 'router.login'
        }
    },
    {
        path: '/t/:tenantKey/login',
        name: 'tenantKeyLogin',
        component: () => import('@/views/login/yssz/login'),
        meta: {
            title: 'router.login'
        }
    },
    {
        path: '/phm/login',
        name: 'phmLogin',
        component: () => import('@/views/login/yssz/login'),
        meta: {
            title: 'router.login'
        }
    },
    {
        path: '/xbksz/login',
        name: 'xbkszLogin',
        component: () => import('@/views/login/xbksz/login'),
        meta: {
            title: 'router.login'
        }
    },
    {
        path: '/downloadPdf',
        name: 'DownloadPdf',
        component: () => import('@/views/downloadPdf/index.vue'),
        meta: {
            title: 'dtReport.DiagnosticReport'
        }
    },
]
const indexRouter = [
    // === 大屏看板（包含 Layout） ===
    {
        path: '/bigscreen/factory',
        name: '/bigscreen/factory',
        meta: { hidden: true },
        children: [
            {
                meta: { hidden: true, title: '工厂驾驶舱大屏' },
                component: () => import('@/views/bigscreen/factoryScreen/index.vue'),
            }
        ]
    },
    {
        path: '/bigscreen/line',
        name: '/bigscreen/line',
        meta: { hidden: true },
        children: [
            {
                meta: { hidden: true, title: '产线驾驶舱大屏' },
                component: () => import('@/views/bigscreen/lineScreen/index.vue'),
            }
        ]
    },
    {
        path: '/bigscreen/device',
        name: '/bigscreen/device',
        meta: { hidden: true },
        children: [
            {
                meta: { hidden: true, title: '设备驾驶舱大屏' },
                component: () => import('@/views/bigscreen/deviceScreen/index.vue'),
            }
        ]
    },
    {
        path: '/alarmsDetails',
        name: '/alarmsDetails',
        meta: {
            hidden: true,
        },
        children: [
            {
                meta: {
                    hidden: true,
                    title: '报警详情'
                },
                component: () => import('@/views/alarms/alarmDetails.vue'),
            },
        ]
    },
    {
        path: '/pAlarmsDetails',
        name: '/pAlarmsDetails',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '报警详情'
                },
                component: () => import('@/views/pAlarms/alarmDetails.vue'),
            },
        ]
    },
    {
        path: '/dtAlarmsDetails',
        name: '/dtAlarmsDetails',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '报警详情'
                },
                component: () => import('@/views/DTPhmAlarms/dtDeviceAlarm/dtAlarmDetails.vue'),
            },
        ]
    },
    {
        path: '/dtSensorAlarmDetails',
        name: '/dtSensorAlarmDetails',
        meta: {
            hidden: true,
            title: '传感器报警详情',
        },
        children: [
            {
                meta: {
                    title: '传感器报警详情',
                    tab:false
                },
                component: () => import('@/views/DtSensorAlarms/DtSensorAlarmDetails.vue'),
            },
        ]
    },
    {
        path: '/devicesDetails',
        name: '/devicesDetails',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '设备详情'
                },
                component: () => import('@/views/devices/devicesDetails.vue'),
            },
        ]
    },
    {
        path: '/iotDetails',
        name: '/iotDetails',
        children: [
            {
                meta: {
                    hidden: true,
                    title: 'IOT详情'
                },
                component: () => import('@/views/devices/devicesDetails.vue'),
            },
        ]
    },
    //设备详情
    {
        path: '/devicesNewDetails',
        name: '/devicesNewDetails',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '设备详情'
                },
                component: () => import('@/views/devicesNew/devicesDetails.vue'),
            },
        ]
    },
    //设备管理详情
    {
        path: '/devicesNewEditDetails',
        name: '/devicesNewEditDetails',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '设备详情'
                },
                component: () => import('@/views/sets/deviceNew/devicesDetails.vue'),
            },
        ]
    },
    //传感器详情
    {
        path: '/sensorInfo',
        name: '/sensorInfo',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '传感器详情'
                },
                component: () => import('@/views/devicesNew/sensorInfo.vue'),
            },
        ]
    },
    {
        path: '/devicesHistory',
        name: '/devicesHistory',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '下载历史'
                },
                component: () => import("@/views/devices/downloadHistory.vue"),
            },
        ]
    },
    {
        path: '/pEditDevice',
        name: '/pEditDevice',
        meta: {
            hidden: true,
        },
        children: [
            {
                meta: {
                    title:'IOT详情'
                },
                component: () => import("@/views/sets/iot/editDevice.vue"),
            },
        ]
    },
    {
        path: '/dEditDevice',
        name: 'dEditDevice',
        meta: {
            hidden: true,
        },
        children: [
            {
                meta: {
                    title:'IOT详情'
                },
                component: () => import("@/views/sets/iot/dEditDevice.vue"),
            },
        ]
    },
    {
        path: '/dtAcquisitionDevice',
        name: 'DtAcquisitionDevice',
        meta: {
            hidden: true,
        },
        children: [
            {
                meta: {
                    title:'数采器详情'
                },
                component: () => import("@/views/sets/acquisitionDeviceConfig/DeviceConfig.vue"),
            },
        ]
    },
    {
        path: '/sets/deviceModel',
        name: 'SingleMachineModel',
        meta: {
            hidden: true,
        },
        children: [
            {
                meta: {
                    hidden: true,
                    title: '设备诊断模型'
                },
                component: () => import("@/views/sets/deviceModel/index.vue"),
            },
        ]
    },
    {
        path: '/editDevices',
        name: '/editDevices',
        meta: {
            hidden: true,
        },
        children: [
            {
                meta: {
                    title:'设备详情'
                },
                component: () => import("@/views/sets/device/editDevice.vue"),
            },
        ]
    },
    //维修记录
    {
        path: '/operation',
        name: 'Operation',
        meta: {
            hidden: true,
        },
        children: [
            {
                component: () => import('@/views/devicesNew/operation/index.vue'),
            }
        ]
    },
    {
        path: '/phmalarm/dtDeviceAlarm/detail',
        name: 'DtDeviceAlarmDetail',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '报警详情'
                },
                component: () => import('@/views/DTPhmAlarms/dtDeviceAlarm/DtNewAlarmDetails.vue'),
            }
        ]
    },
    {
        path: '/knowledgeBase/faultLib/deviceModel',
        name: 'DeviceModel',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '案例库详情'
                },
                component: () => import('@/views/knowledgeBase/faultLib/DeviceModel.vue'),
            }
        ]
    },
    // === AI 诊断中心 ===
    {
        path: '/cockpit/deviceAgent',
        name: 'AiDiagnosisCenter',
        children: [
            {
                meta: {
                    hidden: true,
                    title: 'AI诊断中心'
                },
                component: () => import('@/views/cockpit/deviceAgent/index.vue'),
            }
        ]
    },
    {
        path: '/cockpit/deviceAgent/workbench',
        name: 'DeviceAgentWorkbench',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '设备诊断详情'
                },
                component: () => import('@/views/cockpit/deviceAgent/workbench.vue'),
            }
        ]
    },
    {
        path: '/version-history',
        name: 'version-history',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '版本历史记录'
                },
                component: () => import('@/views/versionHistory/index.vue'),
            }
        ]
    },
    {
        path: '/sets/dept',
        name: 'DeptManagement',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '部门管理'
                },
                component: () => import('@/views/sets/dept/index.vue'),
            }
        ]
    },
    {
        path: '/sets/post',
        name: 'PostManagement',
        children: [
            {
                meta: {
                    hidden: true,
                    title: '岗位管理'
                },
                component: () => import('@/views/sets/post/index.vue'),
            }
        ]
    },

]

const router = new Router({
    routes: baseRouter
})

// 公共路由

function setupRoutes() {
    api.getMenus({versionCodeNum: process.env.VUE_APP_CODE}).then(res => {
        let url = 'index';
        if (store.state.isLt) url = 'lIndex';
        const routeList = res.data || [];
        const permissions = res.permissions || [];

        // 转换菜单为路由配置
        const menus = routeList.map(item => {
            const route = {...item};
            route.component = () => import(`@/views/${url}.vue`);
            // 处理组件动态导入
            if (item.menuType === 'M') {
                if (item.children) {
                    route.children = item.children.map(child => ({
                        ...child,
                        component: () => import(`@/views/${child.component}.vue`)
                    }));
                }
            } else if (item.menuType === 'C') {
                route.children = [{
                    name: route.name,
                    path: route.path, // 空路径表示默认渲染到 Layout 的 <router-view/>
                    component: () => import(`@/views/${item.component}.vue`),
                    meta: route.meta
                }];
            }

            return route;
        });

        // 设置默认重定向路径
        const oneMenu = menus[0];
        let redirectPath = oneMenu?.path || '/';
        if (oneMenu.menuType === 'M') {
            const item = oneMenu.children.find(v => v.isFrame)
            if (item) redirectPath = item.path
        }
        store.commit('setStateValue', {key: 'redirectPath', value: redirectPath});

        // 添加默认重定向路由
        router.addRoute({
            path: '/',
            redirect: redirectPath,
            component: () => import(`@/views/${url}.vue`)
        })
        router.addRoute({
            path: '*', // 捕获所有未定义的路由
            name: 'NotFound',
            component: () => import('@/views/404'),
            meta: {
                title: '404'
            }
        })
        // 存储菜单和权限
        store.commit('setStateValue', {key: 'menus', value: menus});
        store.commit('setStateValue', {key: 'permissions', value: permissions});
        // 添加路由（Vue Router 4.x 方式）
        menus.forEach(route => {
            router.addRoute(route);
        });
        indexRouter.forEach(item => {
            const route = {...item};
            route.component = () => import(`@/views/${url}.vue`);
            route.children[0].path = ''
            router.addRoute(route);
        })
    }).catch(error => {
        console.error("Failed to setup routes:", error);
    });
}

router.beforeEach((to, from, next) => {
    NProgress.start()
    syncTenantKeyFromRoute(to)
    if (to.path.startsWith('/t/') && !to.path.endsWith('/login')) {
        next({path: stripTenantPrefix(to.path), query: to.query})
        NProgress.done()
        return
    }
    const query = to.query
    if (query.token) {
        storage.set('token', query.token)
        store.dispatch('fetchTenantInfo')
    }
    if (query.tenantId) store.commit('setTenantId', query.tenantId)
    const token = storage.get('token')
    storage.remove('treeType')
    // 允许直接访问的路由名数组
    const whiteList = ['/login', '/downloadPdf'];
    if (whiteList.some(item => to.path.includes(item))) {
        next();
        NProgress.done();
    } else {
        if (!token) {
            next(getTenantLoginPath(to));
            NProgress.done()
        } else {
            store.commit('applyTenantFlags')
            if (!store.state.initRegisteredLogin) {
                store.commit('setInitRegisteredLogin', true);
                setupRoutes()
            }
            const name = to.name
            if (!to.meta.hidden && name) {
                activeMenu = name
                store.commit('updateActiveMenu', activeMenu);
                storage.set('activeMenu', activeMenu)
            }
            next();
            NProgress.done()
        }
    }
});

router.afterEach((to, from) => {
    if (to.path.includes('/login') && from.name) {
        router.go(0)
    }
    let title = to.meta.title
    window.document.title = title ? i18n.t(title) : 'RIIMonitor'
});
export default router
